import { useEffect, useMemo, useState } from 'react';
import { usePromise } from '../usePromise/usePromise';
import { useContractReader } from '../../services/contractReader';
import { multiTypePoolManager } from '../../constants/vpool';

// this is the function name that returns the standard time for each stats in secs
const StatusTimeRef = {
  TICKET_SALE: 'ticketSaleDurationSecs', // for example this could return 6000 secs
  PRIVATE_SUBSCRIPTION: 'privateSubscriptionDurationSecs',
  PUBLIC_SUBSCRIPTION: 'publicSubscriptionDurationSecs',
  WHITELIST: 'whitelistingDurationSecs',
  SUBSCRIPTION_PHASE: 'vPoolSubscriptionDurationSecs',
};

export const useStatusTime = (status, isVpool) => {
  const methodName = StatusTimeRef?.[status];
  const [time, setTime] = useState(0);

  const contractMethod = useMemo(
    () => methodName && useContractReader(multiTypePoolManager(isVpool).configContract, methodName),
    [methodName, status],
  );

  useEffect(() => {
    if (!methodName) return;
    contractMethod.then((value) => setTime(+value));
  }, [methodName, status]);

  return time;
};
